import { useEffect, useState } from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

export function PHProvider({ children }: { children: React.ReactNode }) {
	const [hydrated, setHydrated] = useState(false);

	useEffect(() => {
		if (
			process.env.NODE_ENV === "production" ||
			process.env.NODE_ENV === "test"
		) {
			posthog.init("phc_CmZ20YNMQbjtjL2Pjk3pjvxfE6BsCiAye1xwH8zLnN7", {
				api_host: "https://t.amperecreativegroup.com", // your managed reverse proxy domain
				ui_host: "https://us.posthog.com", // necessary because you're using a proxy, this way links will point back to PostHog properly
				person_profiles: "identified_only" // or 'always' to create profiles for anonymous users as well
			});
		}
		setHydrated(true);
	}, []);

	if (!hydrated) return <>{children}</>;
	return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
